import Loader from "components/Loader";
import ReactStrapTable from "components/reactStrapTable";
import React from "react";
import { Card, CardBody } from "reactstrap";
import { cellRendererCheck, currencyFormat, dateFormate } from "utils/columns";

const DrugCatalogPriceHistory = ({ data, loading, acctType }) => {

    let mainCol = [
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.ndc),
        },
        {
            dataField: 'packagePrice',
            text: acctType == '340B' ? '340B Pkg Price' : acctType == 'GPO' ? '	GPO Pkg Price' : 'WAC Pkg Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.packagePrice)
        },
        {
            dataField: 'modifiedByID',
            text: 'Modified By',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.modifiedByID)
        },
        {
            dataFiled: 'modifiedDate',
            text: 'Modified Date',
            sort: false,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.modifiedDate),
        }
    ];

    return (
        <>

            <Card> {loading && <Loader opacity={0.01} color='black' />}
                <CardBody>
                    <div
                        className='table-card scroll-table position-relative border-0 rounded pt-0'
                        fixed-height={0 ? 'fixed-height' : 'default'}
                    >
                        <ReactStrapTable
                            columns={mainCol}
                            data={data}
                        />
                    </div>
                </CardBody>
            </Card>
        </>
    );
};
export default DrugCatalogPriceHistory;